import { render, staticRenderFns } from "./NoDocumentToSendIcon.vue?vue&type=template&id=763f2db8"
import script from "./NoDocumentToSendIcon.vue?vue&type=script&lang=ts"
export * from "./NoDocumentToSendIcon.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports